import {
  http,
  delay,
  HttpResponse,
} from 'msw';

import { createMockEndpoint } from '@/mocks/create-mock-endpoint';
import { AccountDetailResponse } from '@/repositories/generated';

const response: AccountDetailResponse = {
  id: '1',
  name: '山田太郎',
  role: 'SYSTEM_MANAGER',
  status: 'AVAILABLE',
  lockStatus: 'AVAILABLE',
  changedPasswordAt: '2022/12/24 13:10',
  lockedNologinAt: '2023/02/21 13:10',
  loginId: 'test_admin',
  email: 'test_admin@example.com',
  remarks: 'テキストテキストテキストテキストテキストテキスト',
  createdBy: '10',
  createdByName: '佐藤次郎',
  createdAt: '2021/09/24 18:51',
  acquirerId: '1',
  acquirerName: 'テストアクワイアラ1',
  companyId: '0001',
  companyName: 'テスト企業1',
  shopId: '1234',
  shopName: 'テスト店舗 麹町店',
  issuerId: '',
  issuerName: '',
  walletServiceId: '001',
  walletServiceName: '○○Pay',
  updatedAt: '2023/12/20 18:51',
  tenantId: '1',
  tenantName: 'テストテナント',
  giftIssuerId: '',
  giftIssuerName: '',
};

export const accountDetail = http.get(
  createMockEndpoint('/account/:id([^\\(download\\)]+)'), // account/downloadとの競合を避ける
  async () => {
    await delay(500);
    return HttpResponse.json(response, { status: 200 });
  },
);
